import styled from 'styled-components';
import * as theme from '@zero/design-tokens/build/js/variables';

import { GroupingVcpu, UHC_VcpuProps } from './Vcpu';
interface VcpuBackgroundProps {
    groupingVcpu: GroupingVcpu,
    current:UHC_VcpuProps['currentPipe']
}

interface VcpuLabelBackgroundProps extends VcpuBackgroundProps {
    color: string;    
}

export const VcpuLabelBox = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 5px;
`;


export const VcpuDiv = styled.div<VcpuBackgroundProps>`
    flex:${(props) => props.groupingVcpu.blocos};
    width: 100%;
    justify-content: center;
    display: flex;
`;

export const VcpuLabel = styled.p<VcpuLabelBackgroundProps>`
    color: ${(props) => props.current === props.groupingVcpu.vcpu ? (props.color) : 'gray'};
    width: 100%;
    text-align: center;
    font-family: ${theme.ZrFontFamilyDigitalLight};
    font-size: 9.1px;
    font-weight: ${theme.ZrFontWeightBold};
    margin: 0 !important;
    padding: 0 !important;

    @media (max-width: 992px) { 
        width: 80%;
        margin: 0 40% !important;
    }

    @media (max-width: 530px) { 
        font-size: 1rem !important;
    }
`

export const VcpuBackgroundBox = styled.div`
    height: 16px;
    display: flex;
    justify-content: space-between;

`;


export const VcpuBackground = styled.div<VcpuBackgroundProps>`
    flex:${(props) => props.groupingVcpu.blocos};
    width: 100%;
    height: 26px;
    background: 0% 0% no-repeat padding-box;
    background-color: ${(props) => props.current === props.groupingVcpu.vcpu ? (props.color) : theme.ZrColorNeutralLight}; 
    border-right: 4px solid white !important;
    opacity: 0.5 ;
    margin-top: 4px;
`;

